module.exports = __webpack_public_path__ + "img/dlbox.beaeecd3.svg";